import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {TokenInterceptor} from './token.interceptor';
import {HttpErrorInterceptor} from './httperror.interceptor';
import {CustomHeaderInterceptor} from './custom-headers.interceptor';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CustomHeaderInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: TokenInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: HttpErrorInterceptor,
    },
  ],
})
export class GlobalServicesModule {
  constructor(@Optional() @SkipSelf() parentModule: GlobalServicesModule) {
    if (parentModule) {
      throw new Error('GlobalServicesModule is already loaded. Import it in the AppModule only');
    }
  }
}
